module.exports = __webpack_public_path__ + "static/img/pro-img2.db3c806.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pro-img2.jpg
// module id = gdLJ
// module chunks = 0